import { Trans } from "@lingui/react/macro"
import { IconWifiOff } from "@tabler/icons-react"
import classes from "./styles.module.css"

// App-wide offline banner. Rendered by the auth layout whenever the device is
// offline, so the reassurance ("you can keep recording, it's held locally") is
// visible everywhere — not just in the new-meeting dialog. Pure + dumb: the
// layout decides when to show it via useNetworkStatus().
export function GlobalOfflineBanner(): React.JSX.Element {
  return (
    <div className={classes.banner} role="status" aria-live="polite">
      <IconWifiOff size={15} />
      <span>
        <Trans>
          You&apos;re offline — recording still works and is saved on this device. Transcription and insights resume
          when you reconnect.
        </Trans>
      </span>
    </div>
  )
}
